import { FormFieldV2 } from '@/components/custom/erp';
import { usePhuongThucThanhToan } from '@/hooks';
import { FormMode } from '@/types/form';

interface HDDTTabProps {
  formMode: FormMode;
}

export function HDDTTab({ formMode }: HDDTTabProps) {
  const { paymentMethods } = usePhuongThucThanhToan();
  const paymentMethodOptions = paymentMethods.map(paymentMethod => ({
    value: paymentMethod.uuid,
    label: paymentMethod.ten_pttt
  }));

  return (
    <div className='w-full space-y-2 p-3 xl:p-4'>
      <FormFieldV2
        name='ma_tthddt'
        type='select'
        label='Trạng thái HĐĐT'
        disabled={formMode === 'view'}
        labelClassName='w-36 shrink-0 text-[13px] xl:w-40'
        options={[
          { value: '0', label: 'Không sử dụng' },
          { value: '1', label: 'Chờ phát hành' }
        ]}
        value='0'
        className='w-48'
      />

      <FormFieldV2
        name='ma_pttt'
        label='Thanh toán'
        disabled={formMode === 'view'}
        labelClassName='w-36 shrink-0 text-[13px] xl:w-40'
        className='w-48'
        type='select'
        options={paymentMethodOptions}
        value='CK'
      />

      <FormFieldV2
        label='Số hóa đơn'
        name='so_ct_hddt0'
        type='text'
        disabled={formMode === 'view'}
        labelClassName='w-36 shrink-0 text-[13px] xl:w-40'
      />

      <FormFieldV2
        label='Ngày hóa đơn'
        name='ngay_ct_hddt0'
        type='date'
        disabled={formMode === 'view'}
        labelClassName='w-36 shrink-0 text-[13px] xl:w-40'
        className='w-96'
      />

      <FormFieldV2
        label='Ký hiệu'
        name='so_ct2_hddt'
        type='text'
        disabled={formMode === 'view'}
        labelClassName='w-36 shrink-0 text-[13px] xl:w-40'
      />

      <FormFieldV2
        label='Mẫu hóa đơn'
        name='ma_mau_ct_hddt'
        type='text'
        disabled={formMode === 'view'}
        labelClassName='w-36 shrink-0 text-[13px] xl:w-40'
      />
    </div>
  );
}
